/**
 * Asset types
 */
export const AD_ASSET_TYPE = {
  facebookMixtureAd: 'facebook_mixture_ad',
  pinterestMixtureAd: 'pinterest_mixture_ad',
  twitterMixtureAd: 'twitter_mixture_ad',
  linkedinMixtureAd: 'linkedin_mixture_ad',
  linkedinDocumentAd: 'linkedin_document_ad',
  linkedinDocumentAdIntro: 'linkedin_document_ad_intro',
  linkedinDocumentAdHeadline: 'linkedin_document_ad_headline',
  linkedinVideoAdIntro: 'linkedin_video_ad_intro',
  linkedinVideoAdHeadline: 'linkedin_video_ad_headline',
  linkedinVideoAd: 'linkedin_video_ad',
  linkedinTextAd: 'linkedin_text_ad',
  linkedinMessageAd: 'linkedin_message_ad',
  linkedinConversationAd: 'linkedin_conversational_ad',
  linkedinLeadGenFormAd: 'linkedin_lead_gen_form_ad',
  linkedinConversationalAdOpeningMessage: 'linkedin_conversational_ad_opening_message',
  linkedinConversationalAdPrimaryCtaButtonText:
    'linkedin_conversational_ad_primary_cta_button_text',
  linkedinConversationalAdFollowUpMessage: 'linkedin_conversational_ad_follow_up_message',
  linkedinConversationalAdSecondaryCtaButtonText:
    'linkedin_conversational_ad_secondary_cta_button_text',
  linkedinLeadGenFormAdPrimaryText: 'linkedin_lead_gen_form_ad_primary_text',
  linkedinLeadGenFormAdHeadline: 'linkedin_lead_gen_form_ad_headline',
  linkedinLeadGenFormAdOfferHeadline: 'linkedin_lead_gen_form_ad_offer_headline',
  linkedinLeadGenFormAdOfferDetails: 'linkedin_lead_gen_form_ad_offer_details',
  linkedinMessageAdSubject: 'linkedin_message_ad_subject',
  linkedinMessageAdMessage: 'linkedin_message_ad_message',
  linkedinMessageAdCta: 'linkedin_message_ad_cta',
  facebookHeadline: 'facebook_headline',
  facebookPrimaryText: 'facebook_primary_text',
  googlePerformanceMaxAd: 'google_performance_max_ad',
  googleHeadline: 'google_headline',
  googleLongHeadline: 'google_headline_long',
  googleDescription: 'google_description',
  googleRSA: 'google_rsa',
  googleSearchAdHeadline: 'google_search_ad_headline',
  googleSearchAdDescription: 'google_search_ad_description',
  googleShortDescription: 'google_description_short',
  googleDemandGenAd: 'google_demand_gen_ad',
  googleMediumHeadline: 'google_headline_medium',
  googleDemandGenAdLongHeadline: 'google_demand_gen_ad_long_headline',
  googleDemandGenAdDescription: 'google_demand_gen_ad_description',
  googleDisplayAd: 'google_display_ad',
  googleDisplayAdHeadline: 'google_display_ad_headline',
  googleDisplayAdLongHeadline: 'google_display_ad_long_headline',
  googleDisplayAdDescription: 'google_display_ad_description',
  googleShoppingAd: 'google_shopping_ad',
  googleShoppingTitle: 'google_shopping_title',
  googleShoppingDescription: 'google_shopping_description',
  googleVideoAd: 'google_video_ad',
  googleVideoAdHeadline: 'google_video_ad_headline',
  googleVideoAdLongHeadline: 'google_video_ad_long_headline',
  googleVideoAdDescription: 'google_video_ad_description',
  googleAppAd: 'google_app_ad',
  googleAppAdHeadline: 'google_app_ad_headline',
  googleAppAdDescription: 'google_app_ad_description',
  outbrainAd: 'outbrain_ad',
  outbrainHeadline: 'outbrain_headline',
  outbrainDescription: 'outbrain_description',
  outbrainHeadlineProduct: 'outbrain_headline_product',
  outbrainDescriptionProduct: 'outbrain_description_product',
  taboolaAd: 'taboola_ad',
  taboolaHeadline: 'taboola_headline',
  taboolaDescription: 'taboola_description',

  linkedinTextAdHeadline: 'linkedin_text_ad_headline',
  linkedinTextAdDescription: 'linkedin_text_ad_description',
  linkedinTitle: 'linkedin_title',
  linkedinIntro: 'linkedin_intro_copy',
  linkedinSingleImageHeadline: 'linkedin_single_image_headline',
  linkedinSingleImageIntro: 'linkedin_single_image_intro',
  twitterTitle: 'twitter_title',
  twitterCopy: 'twitter_copy',
  youtubeTitle: 'youtube_title',
  youtubeDescription: 'youtube_description',
  pinterestTitle: 'pinterest_title',
  pinterestDescription: 'pinterest_description',

  teadsSingleImageHeadline: 'teads_single_image_headline',
  teadsSingleImageDescription: 'teads_single_image_description',
  teadsSingleVideoHeadline: 'teads_single_video_headline',
  teadsSingleVideoDescription: 'teads_single_video_description',
  teadsCarouselHeadline: 'teads_carousel_headline',
  teadsSocialLayout1Headline: 'teads_social_layout_1_headline',
  teadsSocialLayout1PrimaryText: 'teads_social_layout_1_primary_text',
  teadsSocialLayout1Description: 'teads_social_layout_1_description',
  teadsSocialLayout2PrimaryText: 'teads_social_layout_2_primary_text',
} as const;
export type AdAssetType = (typeof AD_ASSET_TYPE)[keyof typeof AD_ASSET_TYPE];

export const LANDING_ASSET_TYPE = {
  landingHeadline: 'landing_page_headline',
  landingCTA: 'landing_page_call_to_action',
  landingProductDescription: 'landing_page_product_description',
  landingProductName: 'landing_page_product_name',
  landingCopy: 'landing_page_copy',
  landingSEOMetadata: 'landing_page_seo_meta_data',
  landingSEOMetaTitle: 'landing_page_seo_meta_title_tag',
  landingBuilderHeadline: 'landing_page_builder_headline',
  landingBuilderSubHeadline: 'landing_page_builder_headline_supporting_copy',
  landingBuilderHeader: 'landing_page_builder_header',
  landingBuilderCta: 'landing_page_builder_cta',
  reinforcementStatement: 'landing_page_builder_reinforcement_statement',
  benefits: 'landing_page_builder_benefits',
  features: 'landing_page_builder_features',
  landingSectionHeadline: 'landing_page_section_headline',
} as const;
export type LandingAssetType = (typeof LANDING_ASSET_TYPE)[keyof typeof LANDING_ASSET_TYPE];

export const PRODUCT_LISTING_ASSET_TYPE = {
  amazonProductDescription: 'amazon_product_description',
  amazonFeatureList: 'amazon_feature_list',
  walmartProductDescription: 'walmart_product_description',
  walmartFeatureList: 'walmart_feature_list',
  generalProductDescription: 'general_product_description',
  amazonProductListing: 'amazon_product_listing',
  walmartProductListing: 'walmart_product_listing',
  generalProductListing: 'general_product_listing',
} as const;
export type ProductListingAssetType =
  (typeof PRODUCT_LISTING_ASSET_TYPE)[keyof typeof PRODUCT_LISTING_ASSET_TYPE];

export const SOCIAL_ASSET_TYPE = {
  facebookPost: 'facebook_post',
  instagramCaption: 'instagram_caption',
  tweet: 'tweet',
  linkedinPost: 'linkedin_post',
  pinterestMixturePost: 'pinterest_mixture_post',
  youtubeMixturePost: 'youtube_mixture_post',
  pinterestPostTitle: 'pinterest_post_title',
  pinterestPost: 'pinterest_post',
} as const;
export type SocialAssetType = (typeof SOCIAL_ASSET_TYPE)[keyof typeof SOCIAL_ASSET_TYPE];

export const EMAIL_ASSET_TYPE = {
  emailSubject: 'email_subject',
  emailBody: 'email_body',
  emailColdOutreachBody: 'email_cold_outreach_body',
  emailPromotionalBody: 'email_promotional_body',
  emailMixture: 'email_mixture',
  emailHeadline: 'email_headline',
  emailIntroParagraph: 'email_intro_paragraph',
  emailCta: 'email_cta',
  emailSectionHeadline: 'email_section_headline',
  emailHeader: 'email_header',
} as const;
export type EmailAssetType = (typeof EMAIL_ASSET_TYPE)[keyof typeof EMAIL_ASSET_TYPE];

export const BLOG_POST_ASSET_TYPE = {
  blogPostOutline: 'blog_post_outline',
  blogPostIntroParagraph: 'blog_post_intro_paragraph',
  blogPostTitle: 'blog_post_title',
  blogPostContent: 'blog_post_content',
  blogPostList: 'blog_post_list',
  blogPostFacts: 'blog_post_facts',
  blogPostHeadline: 'blog_post_headline',
  blogPostSectionHeadline: 'blog_post_section_headline',
  blogPostSectionSubHeadline: 'blog_post_section_subheadline',
  introParagraph: 'intro_paragraph',
} as const;
export type BlogPostAssetType = (typeof BLOG_POST_ASSET_TYPE)[keyof typeof BLOG_POST_ASSET_TYPE];

export const SMS_ASSET_TYPE = {
  sms: 'sms',
} as const;
export type SmsAssetType = (typeof SMS_ASSET_TYPE)[keyof typeof SMS_ASSET_TYPE];

export const DEPRECATED_ASSET_TYPE = {
  verizonHeadline: 'verizon_headline',
  verizonDescription: 'verizon_description',
  subHeading: 'landing_page_builder_sub_heading',
  subHeadingSupportingCopy: 'landing_page_builder_sub_headline_supporting_copy',
  consumerBenefits: 'consumer_benefits',
  canvasFacebookAd: 'canvas_facebook_ad',
  canvasLandingPage: 'canvas_landing_page_builder',
  canvasInstagramSocial: 'canvas_instagram_social',
  canvasFacebookSocial: 'canvas_facebook_social',
  canvasTwitterSocial: 'canvas_twitter_social',
  canvasLinkedinSocial: 'canvas_linkedin_social',
  canvasPinterestPinSocial: 'canvas_pinterest_pin_social',
  canvasGoogleAd: 'canvas_google_ad',
  canvasYoutubeSocial: 'canvas_youtube_social',
  canvasColdEmail: 'canvas_cold_email',
  canvasLandingPageSeo: 'canvas_landing_page_seo',
  canvasWalmartProductDescription: 'canvas_walmart_product_description',
  canvasWalmartFeatureList: 'canvas_walmart_feature_list',
  canvasAmazonProductDescription: 'canvas_amazon_product_description',
  canvasAmazonFeatureList: 'canvas_amazon_feature_list',
  canvasTwitterAd: 'canvas_twitter_ad',
  canvasLinkedinTextAd: 'canvas_linkedin_text_ad',
  canvasPinterestAd: 'canvas_pinterest_ad',
  canvasPromotionalEmail: 'canvas_promotional_email',
  canvasEmailSubjectLine: 'canvas_email_subject_line',
  canvasSms: 'canvas_sms',
  emailSubjectLine: 'email_subject_line',
  emailColdOutreachSubjectLine: 'email_cold_outreach_subject_line',
  emailPromotionalSubjectLine: 'email_promotional_subject_line',
} as const;
export type DeprecatedAssetType =
  (typeof DEPRECATED_ASSET_TYPE)[keyof typeof DEPRECATED_ASSET_TYPE];

export const CANVAS_ASSET_TYPE = {
  canvasAida: 'canvas_aida',
  canvasPas: 'canvas_pas',
  canvasBab: 'canvas_bab',
  canvasFeatureToBenefitsPractical: 'canvas_feature_to_benefits_practical',
  canvasPerfectHeadline: 'canvas_perfect_headline',
  canvasPersuasiveBulletPoint: 'canvas_persuasive_bullet_point',
  canvasValueProposition: 'canvas_value_proposition',
  canvasProductDescriptionList: 'canvas_product_description_list',
  canvasProductDescriptionRelaxed: 'canvas_product_description_relaxed',
  canvasBlogIdeas: 'canvas_blog_ideas',
  canvasVideoIdeas: 'canvas_video_ideas',
  canvasContentImprover: 'canvas_content_improver',
  canvasEli5: 'canvas_eli5',
  canvasSentenceExpander: 'canvas_sentence_expander',
  canvasFreestyle: 'canvas_freestyle',
  productReview: 'product_review',
  freeTextHeadline: 'free_text_headline',
  freeTextTopic: 'free_text_topic',
  freeTextBody: 'free_text_body',
  personalBio: 'personal_bio',
  companyBio: 'company_bio',
  engagingQuestions: 'engaging_questions',
  quoraAnswers: 'quora_answers',
} as const;
export type CanvasAssetType = (typeof CANVAS_ASSET_TYPE)[keyof typeof CANVAS_ASSET_TYPE];

export const IMAGE_ASSET_TYPE = {
  image: 'image',
  imageWithDescription: 'imageWithDescription',
} as const;
export type ImageAssetType = (typeof IMAGE_ASSET_TYPE)[keyof typeof IMAGE_ASSET_TYPE];

export const LONG_FORM_ASSET_TYPE = {
  longFormSectionHeadline: 'long_form_section_headline',
  longFormTitle: 'long_form_title',
} as const;
export type LongFormAssetType = (typeof LONG_FORM_ASSET_TYPE)[keyof typeof LONG_FORM_ASSET_TYPE];

export const EDITOR_MARKED_ASSET_TYPE = {
  editorRephrase: 'editor_rephrase',
  editorParagraph: 'editor_paragraph',
} as const;
export type EditorMarkedAssetType =
  (typeof EDITOR_MARKED_ASSET_TYPE)[keyof typeof EDITOR_MARKED_ASSET_TYPE];

export const ACTIVE_ASSET_TYPE = {
  ...CANVAS_ASSET_TYPE,
  ...AD_ASSET_TYPE,
  ...LANDING_ASSET_TYPE,
  ...SOCIAL_ASSET_TYPE,
  ...EMAIL_ASSET_TYPE,
  ...BLOG_POST_ASSET_TYPE,
  ...SMS_ASSET_TYPE,
  ...PRODUCT_LISTING_ASSET_TYPE,
  ...EDITOR_MARKED_ASSET_TYPE,
  ...IMAGE_ASSET_TYPE,
  ...LONG_FORM_ASSET_TYPE,
} as const;
export type ActiveAssetType = (typeof ACTIVE_ASSET_TYPE)[keyof typeof ACTIVE_ASSET_TYPE];

export const ASSET_TYPE = {
  ...ACTIVE_ASSET_TYPE,
  ...DEPRECATED_ASSET_TYPE,
} as const;
export type AssetType = (typeof ASSET_TYPE)[keyof typeof ASSET_TYPE];
